import type { ReactElement } from "react";
import { CmtsBackendEndpointCoverageContainer } from "../../core/containers/domain/auditsecurityRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsBackendEndpointCoverageContainer runtime={props.runtime} />;
}

export default Component;
